/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import MomentService from 'cio/services/moment';
import { BaseFormatTimestampArgs } from 'cio/components/format-timestamp';

interface ShortDateArgs extends BaseFormatTimestampArgs {
  alwaysShowTime?: boolean;
  triggerClassNames?: string;
}

export default class ShortDate extends Component<ShortDateArgs> {
  @service moment!: MomentService;

  get alwaysShowTime() {
    return this.args.alwaysShowTime ?? false;
  }

  @action
  finalFormatter(timestampAsMoment: moment.Moment) {
    return this.moment.shortCalendar(timestampAsMoment, { alwaysShowTime: this.alwaysShowTime });
  }
}
